import { useState } from "react";
import type { AvailableApp } from "@/lib/api/controlPlaneClient";
import { appHue } from "./appCardColors";

/** App logo: real image when available, otherwise a coloured initial tile. */
export function AppLogo({
  app,
  size = 48,
  radius = 12,
}: {
  app: AvailableApp;
  size?: number;
  radius?: number;
}) {
  const [imgFailed, setImgFailed] = useState(false);
  const initial = app.app_name.charAt(0).toUpperCase();
  const px = `${size}px`;

  if (app.logo_url && !imgFailed) {
    return (
      <img
        src={app.logo_url}
        alt={app.app_name}
        onError={() => setImgFailed(true)}
        className="object-cover flex-shrink-0"
        style={{ width: px, height: px, borderRadius: radius }}
      />
    );
  }

  return (
    <div
      className="flex items-center justify-center font-semibold text-white flex-shrink-0"
      style={{
        width: px,
        height: px,
        borderRadius: radius,
        fontSize: `${Math.round(size * 0.42)}px`,
        backgroundColor: `hsl(${appHue(app.name)}, 55%, 48%)`,
      }}
      aria-hidden="true"
    >
      {initial}
    </div>
  );
}
